import { ROBOT_PART_REMOVE_SUCCESS } from './removeRobotPartRequest';

export const removeRobotPartSuccess = (ids) => ({
  type: ROBOT_PART_REMOVE_SUCCESS,
  payload: {
    ids,
  },
});
